import axios from 'axios';
import { auth, resError } from '@services/Helpers/ServiceInterceptor';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/VReportsFinancialCenter/',
});

api.interceptors.request.use((config) => auth(config));
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => resError(error)
);

class VReportsFinancialCenter {
  constructor() {
    if (!VReportsFinancialCenter.instance) {
      VReportsFinancialCenter.instance = this;
    }
    return VReportsFinancialCenter.instance;
  }

  search = (filters, orderBy, orderDir, p, fields, perPage) => {
    return api.post('/search', {
      filters: Object.keys(filters).length > 0 ? filters : null,
      orderBy,
      orderDir,
      page: p,
      fields: undefined,
      perPage: parseInt(perPage),
    });
  };

  export = (filters, orderBy, orderDir, p, fields, perPage, config = null) => {
    return api.post(
      '/export',
      {
        filters: Object.keys(filters).length > 0 ? filters : null,
        orderBy,
        orderDir,
        page: p,
        fields: undefined,
        perPage: parseInt(perPage),
      },
      config
    );
  };

  create = (entity) => {
    return api.post('/', entity);
  };

  read = (id) => {
    return api.get('/' + id);
  };

  calculate = (entity) => {
    return api.post('/calculate', entity);
  };

  update = (entity) => {
    return api.put('/', entity);
  };

  delete = (id) => {
    return api.delete('/' + id);
  };

  autoSuggest = (value) => {
    return api.post('/search', { filters: { displayName: value }, perPage: 20, page: 1 });
  };
  sendEmail = (id) => {
    return api.get('/sendemail/' + id);
  };
  generatereport = (id) => {
    return api.get('/generatereport/' + id);
  };
  getfile = (id) => {
    return api.get('/getfile/' + id);
  };
}

const instance = new VReportsFinancialCenter();
Object.freeze(instance);

export default instance;
